import React, { useEffect, useState } from 'react';
import { InputLabel, FormLabel, FormControl, FormControlLabel, Select, MenuItem, Box, Checkbox, TextField, Radio, RadioGroup, Typography ,IconButton, InputAdornment} from "@mui/material"
import CircleCheckedFilled from '@mui/icons-material/CheckCircle';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import DeleteIcon from '@mui/icons-material/Delete';
import { FormikProps } from "formik";
import { completeTimeoutOptions, incompleteTimeoutOptions, promptLatencyOptions, promptTimeoutOptions } from '../../helpers/form.helper';
import { useDrop } from 'react-dnd'
import { useSelector } from 'react-redux';
import { useAppDispatch } from "../../store/hooks";
import { IPrompt } from "../../types/interfaces/prompt.interface";
import { addSelectedPrompts } from '../../store/resuders/prompt.reducer';
import { getSelectedPrompts } from "../../store/selectors/prompt.selector";
import { useTranslation } from 'react-i18next';
import { toggleAlert } from "../../store/resuders/app.reducer";   

export interface IProps {
    formik: FormikProps<any>;
    segmentName?: string;
    type?: string;
    language?: string;
}

export const Listen = ({ formik }: IProps) => {
    // Access the formik values and helpers as needed
    const { values, handleChange } = formik;
    const selectedPrompts = useSelector(getSelectedPrompts);
    const [removePrompts, setRemovePrompts] = React.useState<string[]>([]);
    const [prompts, setPrompts] = useState<IPrompt[]>(selectedPrompts);
    const dispatch = useAppDispatch();
    const [usePromptLibrary, setUsePromptLibrary] = useState(false);
    const { t } = useTranslation();

    const addPromptFromLibrary = (item: any) => {
            const updatedPrompts = [...prompts, item];
            setPrompts(updatedPrompts);
            dispatch(addSelectedPrompts(updatedPrompts));
    }

    const [{ isOver }, drop] = useDrop(() => ({
        accept: 'ROWS',
        drop: addPromptFromLibrary,
        collect: (monitor: any) => ({
            isOver: !!monitor.isOver(),
        }),
    }), [prompts])

    const promptSelectionChanged = (seg: IPrompt) => (e: any) => {
        if (e.target.checked) {
            setRemovePrompts(removePrompts.concat(seg.id))
        } else {
            setRemovePrompts(removePrompts.filter(c => c !== seg.id))

        }
    }

    const handleSelectPromptLibrary = () => {
        console.log('usePromptLibrary', usePromptLibrary);
        setUsePromptLibrary(!usePromptLibrary)
        handleChange({ target: { name: 'selectPromptLibrary', value: !usePromptLibrary } });
    }
    const handleRemovePrompt = (libraryID: any, index: number) => {
        const updatedPrompts = prompts.filter((prompt, i) => i !== index);
        console.log('updatedPrompts', updatedPrompts);
        setPrompts(updatedPrompts);
        dispatch(addSelectedPrompts(updatedPrompts));
    };

    useEffect(() => {
        if(values?.selectPromptLibrary) {
            setUsePromptLibrary(true);
        }
        formik.setFieldValue('libraryItemIds', prompts?.map(p => ({ libraryID: p.libraryID })));
    }, [prompts]);


    // Style property for textfield prompts
    const boldStyle = { fontWeight: 'bold' };
    const promptString = prompts.map(prompt => `${prompt.libraryID} ${prompt.name}`).join('\n');
    return (
        <>
            <Box className='prompt-select' ref={usePromptLibrary ? drop : null}>
                <FormControl sx={{ width: "100%" }}>
                    {usePromptLibrary || prompts?.filter(p => p.libraryID)?.length ? (
                        <>
                            {!prompts?.length ? (
                                <>
                                    <InputLabel id="case-editor-prompt"></InputLabel>
                                    <TextField
                                        id="prompt"
                                        name='prompt'
                                        value={"Add Prompt from the Library"}
                                        label={t("Prompt")}
                                        onChange={formik.handleChange}
                                    />
                                </>) : (
                                <>
                              <TextField
                                id="prompts"
                                name="prompts"
                                inputProps={{
                                    style: boldStyle,
                                }}
                                label={t("Prompts")}
                                onChange={() => {}}
                                multiline
                                rows={prompts.length}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" style={{ display: 'inline-table', flexDirection: 'column', alignItems: 'flex-start', width: '100%', overflow: 'auto', maxHeight: '150px' }}>
                                            {prompts.map((prompt,index) => (
                                                <Box key={index} style={{ display: 'flex', alignItems: 'center', width: '100%',  flexWrap: 'wrap' }}>
                                                    <Typography style={{ whiteSpace: 'pre-wrap', flexGrow: 1 }}>
                                                        {`${prompt.libraryID} ${prompt.name}`}
                                                    </Typography>
                                                    <IconButton onClick={() => handleRemovePrompt(prompt.libraryID, index)}>
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </Box>
                                            ))}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            </>
                            )}


                        </>
                    ) : (
                        <>
                            <TextField
                                id="prompt"
                                name='prompt'
                                variant="standard"
                                value={values.prompt}
                                label={t("Prompt")}
                                onChange={handleChange}
                                InputLabelProps={{ shrink: Boolean(values?.prompt) }}
                                multiline
                                minRows={1}
                                maxRows={4}
                            />
                        </>
                    )}
                </FormControl>
                <FormControl>
                    <FormControlLabel
                        name="case-select-prompt-library"
                        control={
                            <Checkbox
                                id='selectPromptLibrary'
                                name='selectPromptLibrary'
                                icon={<CircleUnchecked />}
                                checkedIcon={<CircleCheckedFilled />}
                                checked={values?.selectPromptLibrary}
                                value={values?.selectPromptLibrary}
                                onChange={handleSelectPromptLibrary}
                            />
                        }
                        label={t("Select From the Prompt Library")}
                        labelPlacement="end"
                    />
                </FormControl>
            </Box>

            <Box sx={{ display: 'flex' }}>
                {/* Left Side of Prompt Library */}
                <Box className='prompt-library-left' sx={{ width: '50%', pr: 1 }}>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-latency-min" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Prompt Latency Min')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    labelId="case-editor-latency-min"
                                    id="promptLatencyMin"
                                    name='promptLatencyMin'
                                    value={values?.promptLatencyMin}
                                    label={t("latency-min")}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {promptLatencyOptions.map(id => (
                                        <MenuItem value={id} key={`lat-min-${id}`}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-incomplete-timeout" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Incomplete Timeout')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    labelId="case-editor-incomplete-timeout"
                                    id="incompleteTimeout"
                                    name='incompleteTimeout'
                                    value={values?.incompleteTimeout}
                                    label={t("incomplete-timeout")}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {incompleteTimeoutOptions.map(id => (
                                        <MenuItem value={id} key={`inc-timeout-${id}`}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-prompt-timeout" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Prompt Timeout')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    labelId="case-editor-prompt-timeout"
                                    id="stepTimeout"
                                    name='stepTimeout'
                                    value={values?.stepTimeout}
                                    label={t("prompt-timeout")}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {promptTimeoutOptions.map(id => (
                                        <MenuItem value={id} key={`prompt-timeout-${id}`}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Box>


                {/* Right Side of Prompt Library */}
                <Box className='prompt-library-right' sx={{ width: '50%', pl: 1 }}>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-latency-max" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Prompt Latency Max')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    labelId="case-editor-latency-max"
                                    id="promptLatencyMax"
                                    name="promptLatencyMax"
                                    value={values?.promptLatencyMax}
                                    label={t("latency-max")}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {promptLatencyOptions.map(id => (
                                        <MenuItem value={id} key={`lat-max-${id}`}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-complete-timeout" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Complete Timeout')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    labelId="case-editor-complete-timeout"
                                    id="completeTimeout"
                                    name="completeTimeout"
                                    value={values?.completeTimeout}
                                    label={t("complete-timeout")}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {completeTimeoutOptions.map(id => (
                                        <MenuItem value={id} key={`comp-timeout-${id}`}>{id}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                    <Box>
                        <div className="prompt-library-dropdowns-compact">
                            <FormControl sx={{ width: "65%" }}>
                                <FormLabel htmlFor="case-editor-prompt-confidence" sx={{ fontSize: '12px', lineHeight: 1.2 }}>{t('Prompt Confidence')}:</FormLabel>
                            </FormControl>
                            <FormControl sx={{ width: "35%" }}>
                                <Select
                                    id="promptConfidenceLevel"
                                    name="promptConfidenceLevel"
                                    value={values?.promptConfidenceLevel}
                                    onChange={handleChange}
                                    variant="standard"
                                    sx={{ 
                                        fontSize: '11px',
                                        height: '24px',
                                        '& .MuiSelect-select': { 
                                            paddingRight: '16px !important',
                                            fontSize: '11px',
                                            paddingTop: '0px',
                                            paddingBottom: '0px',
                                            lineHeight: '24px',
                                            minHeight: 'unset'
                                        },
                                        '& .MuiSelect-icon': {
                                            right: '0px',
                                            fontSize: '14px',
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        },
                                        '& .MuiInput-underline:before': {
                                            borderBottomWidth: '1px'
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomWidth: '1px'
                                        }
                                    }}
                                >
                                    {[0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0].map(val => (
                                        <MenuItem value={val} key={`conf-${val}`}>{val}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>
                    </Box>
                </Box>
            </Box >
            {/* Radio Buttons */}
            <Box className="prompt-library-checkbox">
                <RadioGroup
                    row
                    aria-labelledby="demo-form-control-label-placement"
                    id='voiceOrDTMF'
                    name="voiceOrDTMF"
                    value={values?.voiceOrDTMF}
                    onChange={handleChange}
                >
                    <FormControl sx={{ width: "50%" }}>
                        <FormControlLabel
                            value={false}
                            control={<Radio />}
                            label={t("Voice Only")}
                            labelPlacement="end"
                        />
                    </FormControl>
                    <FormControl sx={{ width: "50%" }}>
                        <FormControlLabel
                            value={true}
                            control={<Radio />}
                            label={t("DTMF Only")}
                            labelPlacement="end"
                        />
                    </FormControl>
                </RadioGroup>
            </Box>

            <Box className="prompt-library-checkbox">
                <FormControl sx={{ width: "50%" }}>
                    <FormControlLabel
                        name="case-select-barge-in"
                        control={
                            <Checkbox
                                id='grammar'
                                name='grammar'
                                checked={values?.grammar?.[0]}
                                onChange={handleChange} />
                        }
                        label={t("Use In-line Grammar")}
                        labelPlacement="end"
                    />
                </FormControl>
            </Box>
        </>
    );
};
